export const Roles = {
  CUSTOMER: "CUSTOMER",
  ADVISOR: "ADVISOR",
  BOOKKEEPER: "BOOKKEEPER",
  CPA: "CPA",
};

export const PermissionFields = [
  { key: "video", label: "Explainer Video" },
  { key: "presentation", label: "Presentation" },
  { key: "interactivePresentation", label: "Interactive Presentation" },
  { key: "benefitCalculator", label: "Benefit Calculator" },
  { key: "dashboard", label: "Old Dashboard" },
  { key: "solarTracker", label: "Solar Widget" },
  { key: "learnMore", label: "Overview" },
  { key: "additionalResources", label: "Additional Resources" },
  { key: "scheduleCallWithCpa", label: "Schedule Call with CPA" },
  { key: "proforma", label: "Proforma" },
  { key: "inviteOthers", label: "Invite Others" },
  { key: "equityContribution", label: "Equity Contribution" },
  { key: "signDocuments", label: "Sign Documents" },
  { key: "myDocuments", label: "My Documents" },
  { key: "createCpa", label: "Create CPA" },
  { key: "createBookkeeper", label: "Create Bookkeeper" },
  { key: "createAdvisor", label: "Create Advisor" },
  { key: "updateCpa", label: "Update CPA" },
  { key: "updateBookkeeper", label: "Update Bookkeeper" },
  { key: "updateAdvisor", label: "Update Advisor" },
];
